import GenericEditor from './GenericEditor.vue';

export default GenericEditor;
